import { useToast } from '@/component/Toast';
import { Rating } from '@/feature/chatbot/api.types';
import { ChatMessage } from '@/feature/chatbot/types';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useRateMessage } from '@/feature/chatbot/useRateMessage';
import { useTexts } from '@/feature/lang';
import { useRatingOptions } from './useRatingOptions';

export const useRating = (message?: ChatMessage) => {
  const texts = useTexts().component.chatbot.rating;
  const { success } = useToast();
  const { conversation, setMessage } = useChatbot();
  const saveRating = useRateMessage(conversation?.id, message?.id);
  const options = useRatingOptions();

  const castVote = (newRating?: Rating) => {
    if (!message) {
      throw new Error('Message is undefined');
    }
    success(newRating ? texts.feedbackSubmitted : texts.feedbackRemoved);
    setMessage({ ...message, rating: newRating });
    saveRating(newRating);
  };

  return { rating: message?.rating, castVote, options };
};
